// @ts-check

import { onDomReady } from '../utils/dom';

function responsiveTable() {
    /** @type {NodeListOf<HTMLTableCellElement>} */
    const cells = document.querySelectorAll('.content-text table tbody th');

    cells.forEach((cell) => {
        const span = document.createElement('span');
        span.innerHTML = cell.innerHTML;
        cell.innerHTML = '';
        cell.appendChild(span);
        cell.parentElement?.style.setProperty('--heading-height', `${span.clientHeight}px`);
    });

    window.addEventListener('resize', () => {
        cells.forEach((cell) => {
            cell.parentElement?.style.setProperty('--heading-height', `${cell.firstElementChild?.clientHeight}px`);
        });
    });
}

onDomReady(() => {
    responsiveTable();
});
